"use client"

import { useState } from "react"
import Footer from "../../components/Shared/Footer"
import styles from "./Submit.module.css"
import board from "assets/images/svg/Mask group.svg";

const MembersForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    nationalId: "",
    age: "",
    city: "",
    address: "",
    faculty: "",
    department: "",
    level: "",
    previousMember: "",
    season: "",
    track: "",
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    console.log(formData)
  }

  const handleInputChange = (e) => {
    const { id, value } = e.target
    setFormData({ ...formData, [id]: value })
  }

  const handleRadioChange = (name, value) => {
    setFormData({ ...formData, [name]: value })
  }

  return (
    <main className={styles.Sbmitpage}>
      <div className={styles.container}>
        {/* Header Section */}
        <div className={styles.header}>
          <h1 className={styles.title}>Season 2025 - Members Recruitment</h1>
          <p className={styles.subtitle}>Fill in this form and someone from our team will contact you soon!</p>
        </div>

        {/* Main Form Container */}
        <div className={styles.formContainer}>
          {/* Hero Image */}
          <div className={styles.heroImage}>
            <img
              src={board}
              alt="IEEE Recruitment"
              className={styles.heroImageContent}
            />
          </div>

          {/* Description */}
          <p className={styles.description}>
            IEEE is Institute of Electrical and Electronics Engineers. Founded in 1963, IEEE has since grown into a
            global community of over 400,000 members from academia, industry, and government sectors. IEEE KSB is an
            abbreviation for IEEE Kafrelsheikh University Student Branch. It is one of 65 Branches across Egyptian
            Universities. Note: All Answers in English ONLY
          </p>

          {/* Form */}
          <form onSubmit={handleSubmit} className={styles.form}>
            <div className={styles.formGrid}>
              {/* Name Input */}
              <div className={styles.formField}>
                <label htmlFor="name" className={styles.label}>
                  Name <span className={styles.required}>*</span>
                </label>
                <input
                  id="name"
                  placeholder="Ex. Muhammed Ahmed"
                  className={styles.input}
                  value={formData.name}
                  onChange={handleInputChange}
                />
              </div>

              {/* Email Input */}
              <div className={styles.formField}>
                <label htmlFor="email" className={styles.label}>
                  Email <span className={styles.required}>*</span>
                </label>
                <input
                  id="email"
                  type="email"
                  placeholder="Ex. example@gmail.com"
                  className={styles.input}
                  value={formData.email}
                  onChange={handleInputChange}
                />
              </div>

              {/* Mobile Number */}
              <div className={styles.formField}>
                <label htmlFor="mobile" className={styles.label}>
                  Mobile Number <span className={styles.required}>*</span>
                </label>
                <input
                  id="mobile"
                  placeholder="Ex. 01xxxxxxxxx"
                  className={styles.input}
                  value={formData.mobile}
                  onChange={handleInputChange}
                />
              </div>

              {/* National ID */}
              <div className={styles.formField}>
                <label htmlFor="nationalId" className={styles.label}>
                  National ID <span className={styles.required}>*</span>
                </label>
                <input
                  id="nationalId"
                  placeholder="Ex. 30101011234567"
                  className={styles.input}
                  value={formData.nationalId}
                  onChange={handleInputChange}
                />
              </div>

              {/* Age */}
              <div className={styles.formField}>
                <label htmlFor="age" className={styles.label}>
                  Age <span className={styles.required}>*</span>
                </label>
                <input
                  id="age"
                  placeholder="Ex. 20"
                  className={styles.input}
                  value={formData.age}
                  onChange={handleInputChange}
                />
              </div>

              {/* City */}
              <div className={styles.formField}>
                <label htmlFor="city" className={styles.label}>
                  City <span className={styles.required}>*</span>
                </label>
                <input
                  id="city"
                  placeholder="Ex. Kafr El-Sheikh"
                  className={styles.input}
                  value={formData.city}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            {/* Address */}
            <div className={styles.formField}>
              <label htmlFor="address" className={styles.label}>
                Address <span className={styles.required}>*</span>
              </label>
              <input
                id="address"
                placeholder="Ex. 123 Street Name"
                className={styles.input}
                value={formData.address}
                onChange={handleInputChange}
              />
            </div>

            <div className={styles.formGrid}>
              {/* Faculty */}
              <div className={styles.formField}>
                <label htmlFor="faculty" className={styles.label}>
                  Faculty <span className={styles.required}>*</span>
                </label>
                <input
                  id="faculty"
                  placeholder="Ex. Computer Science"
                  className={styles.input}
                  value={formData.faculty}
                  onChange={handleInputChange}
                />
              </div>

              {/* Department */}
              <div className={styles.formField}>
                <label htmlFor="department" className={styles.label}>
                  Department <span className={styles.required}>*</span>
                </label>
                <input
                  id="department"
                  placeholder="Ex. Computer Science"
                  className={styles.input}
                  value={formData.department}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            {/* Level */}
            <div className={styles.radioGroup}>
              <label className={styles.label}>
                Level <span className={styles.required}>*</span>
              </label>
              <div className={styles.radioOptions}>
                {[1, 2, 3, 4].map((level) => (
                  <div key={level} className={styles.radioOption}>
                    <input
                      type="radio"
                      id={`level-${level}`}
                      name="level"
                      value={level.toString()}
                      onChange={() => handleRadioChange("level", level.toString())}
                      className={styles.radioInput}
                    />
                    <label htmlFor={`level-${level}`} className={styles.radioLabel}>
                      Level {level}
                    </label>
                  </div>
                ))}
              </div>
            </div>

            {/* Previous Member */}
            <div className={styles.radioGroup}>
              <label className={styles.label}>
                Were you an IEEE member before? <span className={styles.required}>*</span>
              </label>
              <div className={styles.radioOptions}>
                <div className={styles.radioOption}>
                  <input
                    type="radio"
                    id="previous-yes"
                    name="previousMember"
                    value="yes"
                    onChange={() => handleRadioChange("previousMember", "yes")}
                    className={styles.radioInput}
                  />
                  <label htmlFor="previous-yes" className={styles.radioLabel}>
                    Yes
                  </label>
                </div>
                <div className={styles.radioOption}>
                  <input
                    type="radio"
                    id="previous-no"
                    name="previousMember"
                    value="no"
                    onChange={() => handleRadioChange("previousMember", "no")}
                    className={styles.radioInput}
                  />
                  <label htmlFor="previous-no" className={styles.radioLabel}>
                    No
                  </label>
                </div>
              </div>
            </div>

            {/* Season */}
            {formData.previousMember === "yes" && (
              <div className={styles.formField}>
                <label htmlFor="season" className={styles.label}>
                  If yes, Which season? If no type N/A <span className={styles.required}>*</span>
                </label>
                <input
                  id="season"
                  placeholder="Ex. 2023"
                  className={styles.input}
                  value={formData.season}
                  onChange={handleInputChange}
                />
              </div>
            )}

            {/* Track Selection */}
            <div className={styles.radioGroup}>
              <label className={styles.label}>
                Which Track are you applying for? <span className={styles.required}>*</span>
              </label>
              <div className={styles.radioOptions}>
                {["technical", "non-technical", "programming"].map((track) => (
                  <div key={track} className={styles.radioOption}>
                    <input
                      type="radio"
                      id={`track-${track}`}
                      name="track"
                      value={track}
                      onChange={() => handleRadioChange("track", track)}
                      className={styles.radioInput}
                    />
                    <label htmlFor={`track-${track}`} className={styles.radioLabel}>
                      {track.charAt(0).toUpperCase() + track.slice(1)} Track
                    </label>
                  </div>
                ))}
              </div>
            </div>

            {/* Submit Button */}
            <button type="submit" className={styles.submitButton}>
              Send
            </button>
          </form>
        </div>
      </div>
      <Footer />
    </main>
  )
}

export default MembersForm

